/**
 * The three werkkwaliteit permission names, and the one predicate that reads them.
 *
 * Story 4.1 / AD-15. The names themselves are rows in `permissions` handed out by story 3.1
 * (`packages/database/src/werkkwaliteit-permissions.ts`); they are Dutch because that is what the
 * database holds, while the folders around them are English (beslecht punt 1). They are retyped
 * here rather than imported: `@xxtract/database` carries drizzle and a MySQL driver, which have no
 * business in a browser bundle. `permissions.drift.test.ts` reads the database package from disk
 * and fails the moment the two spellings part ways, so the copy cannot rot in silence.
 */
export const WERKKWALITEIT_READ_OWN = 'werkkwaliteit.read.own';
export const WERKKWALITEIT_READ_ALL = 'werkkwaliteit.read.all';
export const WERKKWALITEIT_SETTINGS = 'werkkwaliteit.settings';

/** Any one of the three opens the module — the menu item and the route stem. */
export const WERKKWALITEIT_PERMISSIONS = [
  WERKKWALITEIT_READ_OWN,
  WERKKWALITEIT_READ_ALL,
  WERKKWALITEIT_SETTINGS,
] as const;

/**
 * The two that open a door onto somebody else. Mirrors `WORK_QUALITY_BROAD_PERMISSIONS` in
 * `apps/api/src/modules/work-quality/work-quality.token.ts`: `werkkwaliteit.read.own` is a
 * threshold into the module, never a key to a colleague.
 */
export const WERKKWALITEIT_BROAD_PERMISSIONS = [
  WERKKWALITEIT_READ_ALL,
  WERKKWALITEIT_SETTINGS,
] as const;

/** The one right that opens the threshold setting, and it does not come with the broad read. */
export const WERKKWALITEIT_SETTINGS_PERMISSIONS = [WERKKWALITEIT_SETTINGS] as const;

/**
 * True when `held` contains at least one entry of `required`, compared whole and exactly.
 * Never a prefix or a substring: `werkkwaliteit.read.ownership` is not `werkkwaliteit.read.own`.
 */
export function hasAnyPermission(held: readonly string[] | undefined, required: readonly string[]): boolean {
  if (!Array.isArray(held) || held.length === 0) return false;
  return required.some((name) => held.includes(name));
}
